module.exports = __webpack_public_path__ + "img/nav2h.7ddc1e17.png";